import { Tooltip } from "@design-system/DataDisplay/Tooltip";
import { Icon } from "@design-system/Icon";
import { FlexRow } from "@design-system/Layout/Flex";
import { Text } from "@design-system/Typography/Text";
import { useSetAtom } from "jotai";
import { type FC } from "react";
import { isAiProgressPopupOpenAtom } from "./ctx";
import { useAiProgressPopupTranslations } from "./i18n";

export const Header: FC<{
    questionCount: number;
    isGenerating: boolean;
    isCollapsed: boolean;
    setIsCollapsed: (isCollapsed: boolean) => void;
}> = ({ questionCount, isGenerating, isCollapsed, setIsCollapsed }) => {
    const setIsAiProgressPopupOpen = useSetAtom(isAiProgressPopupOpenAtom);
    const handleCollapseClick = () => {
        setIsCollapsed(!isCollapsed);
    };

    const handleCloseClick = () => {
        if (isGenerating) {
            return;
        }
        setIsAiProgressPopupOpen(false);
    };

    const { t, keys } = useAiProgressPopupTranslations();

    return (
        <FlexRow
            p="4"
            alignItems="center"
            justifyContent="between"
            className="rounded-t-xxl bg-accent-1-50"
        >
            <FlexRow gap="1" alignItems="center">
                <Icon name="stars" size="sm" className="text-accent-1-400" />
                <Text
                    variant="body-sm-bold"
                    className="bg-gradient-to-r from-[#C238CC] to-[#B554F2] bg-clip-text text-transparent"
                >
                    {t(keys.header_title, {
                        count: questionCount,
                        context: !isGenerating && "completed",
                    })}
                </Text>
            </FlexRow>
            <FlexRow gap="4" alignItems="center">
                <Icon
                    className="cursor-pointer"
                    name={isCollapsed ? "chevronUp" : "chevronDown"}
                    onClick={handleCollapseClick}
                />
                <Tooltip>
                    <Tooltip.Trigger>
                        <Icon
                            className={
                                isGenerating
                                    ? "cursor-not-allowed"
                                    : "cursor-pointer"
                            }
                            name="close"
                            onClick={handleCloseClick}
                        />
                    </Tooltip.Trigger>
                    {isGenerating && (
                        <Tooltip.Content>
                            <Text>{t(keys.tooltip)}</Text>
                        </Tooltip.Content>
                    )}
                </Tooltip>
            </FlexRow>
        </FlexRow>
    );
};
